import { Address } from '@/models/address/Address';
import { CategoryDetails } from '@/models/category-details/category-details';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { CartStateService } from '@services/cartStateService';
import { ConfigService } from '@services/config.service';
import { DateTime } from 'luxon';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
declare var Razorpay: any;

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss']
})
export class CartPageComponent implements OnInit {

  currentYear = DateTime.now().toFormat('y');
  items: any[] = [];
  buyerType: 'USER' | 'RESELLER' = 'USER';
  userAddresses: any[] = [];
  showAddressForm = false;
  newAddress: any = {};
  showSummary = false;
  submitted = false;
  shippingDetails: any[] = [];
  selectedShipping: any;
  resellerName: string = "";
  resellerPhone: string = "";
  gstNumber: string = "";
  resellerSubmitted = false;
  phonePattern = /^[6-9]\d{9}$/;
  shipping = 0;

  taxRate: number = 0;
  cartId: number = 0;
  userId: number = 0;

  showNewAddressForm = false;
  addressSubmitted = false;
  isEditMode = false;
  editingIndex: number | null = null;
  categoryDetails: CategoryDetails[] = [];
  paymentMode: string = "PREPAID";
  codCharge = 0;
  isCodAvailable = false;
  shippingAmount: number = 0;
  codAmount: number = 0;
  totalCharges: number = 0;
  quantity: number = 0;
  selectedCategory: number = 0;
  selectedShippingPartner: string = '';
  categoryList: any[] = [];
  productTotal: number = 0;
  discountTotal: number = 0;
  orderValue: number = 0;
  payNowAmount: number = 0;
  payLaterAmount: number = 0;
  showDiscount = false;
  showShipping = false;
  showCOD = false;
  isProcessingPayment = false;
  razorpayKey: string = "";
  selectedUserAddressId: number | null = null;
  shippingPartner: string = "";
  phoneError: boolean = false;
  resellerPhoneTouched = false;
  selectedState: string = "";
  private confirmingOrder = false;
  private currentRazorpayOrderId = '';
  private paymentTimeoutHandle: ReturnType<typeof setTimeout> | null = null;
  private paymentFlowFinished = false;
  private checkoutDismissed = false;

  private readonly paymentScreenName = 'Checkout Screen';


  allStates = [
    'Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam',
    'Bihar', 'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir',
    'Jharkhand', 'Karnataka', 'Kerala', 'Ladakh', 'Lakshadweep', 'Madhya Pradesh',
    'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha',
    'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
    'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  ];

  tamilNaduStates = new Set(['tamil nadu']);

  southIndiaStates = new Set([
    'andhra pradesh',
    'karnataka',
    'kerala',
    'telangana',
    'puducherry'
  ]);

  // ===== UI =====
  endPoint: string = '';
  addressForm!: FormGroup;

  constructor(
    private appService: AppService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private config: ConfigService,
    private fb: FormBuilder,
    private cartState: CartStateService,
  ) { }

  ngOnInit(): void {
    this.getByCustomerCartDetails();
    this.addressForm = this.fb.group({
      name: ['', Validators.required],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)   // Indian mobile format
      ]],
      doorNo: ['', Validators.required],
      streetName: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      pinCode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
      // OPTIONAL FIELDS
      area: [''],
      village: [''],
      landmark: [''],
      gstNumber: [''],
    });
    this.endPoint = this.config.getConfig().END_POINT;
    this.razorpayKey = this.config.getConfig().RAZORPAY_KEY;
  }


  onBuyerTypeChange() {
    this.shippingDetails = [];
    this.selectedShipping = null;

    // Reset reseller fields
    this.resellerName = '';
    this.resellerPhone = '';
    this.gstNumber = '';

    this.resellerSubmitted = false;
  }

  handleIndianPhone(event: any, type: 'address' | 'reseller') {

    let value = event.target.value || '';

    // allow digits only
    value = value.replace(/[^0-9]/g, '');

    // max 10 digits
    value = value.substring(0, 10);

    if (type === 'address') {

      const control = this.addressForm.get('phoneNumber');

      control?.setValue(value);
      control?.markAsTouched();   // important for showing error
      control?.updateValueAndValidity();

    }

    if (type === 'reseller') {

      this.resellerPhone = value;
      this.resellerPhoneTouched = true;

    }
  }

  openAddressForm() {

    // Prevent adding more than one new address
    // if (this.userAddresses.length > 0 && !this.isEditMode) {
    //   this.toastr.info('You can edit existing address instead of adding new one');
    //   return;
    // }

    this.addressForm.reset();
    this.showAddressForm = true;
    this.addressSubmitted = false;
  }

  get f() {
    return this.addressForm.controls;
  }

  getZoneByState(state: string): string {

    const s = state.trim().toLowerCase();

    if (this.tamilNaduStates.has(s)) return 'Tamil Nadu';

    if (this.southIndiaStates.has(s)) return 'South India';

    return 'North India';
  }

  saveAddress() {

    this.addressSubmitted = true;

    if (this.addressForm.invalid) {
      this.toastr.warning('Please fill all required address fields');
      return;
    }

    const formValue = this.addressForm.value;

    const payload = {
      addressId: this.isEditMode ? this.userAddresses[this.editingIndex!].addressId : 0,
      addressType: 'DELIVERY',
      name: formValue.name.trim(),
      phoneNumber: formValue.phoneNumber,
      doorNo: formValue.doorNo.trim(),
      streetName: formValue.streetName.trim(),
      area: formValue.area || '',
      village: formValue.village || '',
      city: formValue.city || '',
      landmark: formValue.landmark || '',
      state: formValue.state,
      gstNumber: formValue.gstNumber || '',
      pinCode: formValue.pinCode,
      userId: this.isEditMode ? this.userAddresses[this.editingIndex!].userId : 0,
      buyerType: this.buyerType
    };

    // CASE 1: Existing Address → UPDATE API
    if (payload.addressId && payload.addressId !== 0) {

      this.spinner.show();

      this.appService.updateUserAddress([payload]).subscribe({
        next: () => {
          this.spinner.hide();

          // update locally also
          this.userAddresses[this.editingIndex!] = payload;

          this.afterAddressSave(payload, 'Address updated successfully');
        },
        error: err => {
          this.spinner.hide();
          this.toastr.error(err.error?.message || 'Update failed');
        }
      });

      return;
    }

    // CASE 2: New Address → LOCAL SAVE ONLY
    if (this.isEditMode) {
      // editing unsaved address
      this.userAddresses[this.editingIndex!] = payload;
    } else {
      // adding new address
      this.userAddresses.push(payload);
    }

    this.afterAddressSave(payload, 'Address added successfully');
  }

  afterAddressSave(address: any, message: string) {

    this.selectedUserAddressId = address.addressId; // may be 0 also

    this.showAddressForm = false;
    this.isEditMode = false;
    this.editingIndex = null;

    this.addressForm.reset();
    this.addressSubmitted = false;

    this.toastr.success(message);
  }


  editAddress(address: any, index: number) {
    this.isEditMode = true;
    this.editingIndex = index;
    this.showAddressForm = true;

    // Reset validation state
    this.addressSubmitted = false;

    // Patch values into form
    this.addressForm.patchValue({
      name: address.name,
      phoneNumber: address.phoneNumber,
      doorNo: address.doorNo,
      streetName: address.streetName,
      area: address.area || '',
      village: address.village || '',
      city: address.city || '',
      landmark: address.landmark || '',
      state: address.state,
      gstNumber: address.gstNumber || '',
      pinCode: address.pinCode
    });
  }

  selectShipping(ship: any) {
    this.selectedShipping = ship;
    this.shipping = ship.amount;
    this.shippingPartner = ship.shippingPartner;
    this.showSummary = true;
  }


  validateReseller(): boolean {

    this.resellerSubmitted = true;

    if (this.buyerType !== 'RESELLER') {
      return true;
    }

    if (!this.resellerName || !this.resellerName.trim()) {
      return false;
    }

    if (!this.resellerPhone || !this.phonePattern.test(this.resellerPhone)) {
      return false;
    }

    return true;
  }

  onShippingSelect(ship: any) {

    this.selectedShipping = ship;

    this.shipping = ship.amount || 0;
    this.shippingPartner = ship.shippingPartner;

    this.updatePaymentBreakup();

  }

  onPaymentModeChange(mode: string) {

    this.paymentMode = mode;

    this.calculateCODCharges();

    this.updatePaymentBreakup();

  }



  placeOrder(): void {
  if (this.isProcessingPayment || this.confirmingOrder) {
    return;
  }

  this.trackPaymentEvent(
    'PAYMENT_BUTTON_CLICKED',
    `Place order button clicked, cartId=${this.cartId}`
  );

  this.submitted = true;

  if (!this.items || this.items.length === 0) {
    this.toastr.error('Your cart is empty. Please add products.');
    return;
  }

  if (
    this.selectedUserAddressId === null ||
    this.selectedUserAddressId === undefined
  ) {
    this.toastr.warning('Please select a delivery address.');
    this.showAddressForm = true;
    return;
  }

  const selectedAddress = this.getSelectedAddress();

  if (!selectedAddress) {
    this.toastr.error('Selected delivery address was not found.');
    return;
  }

  if (this.shippingDetails?.length > 0 && !this.selectedShipping) {
    this.toastr.warning('Please choose a delivery method.');
    return;
  }

  if (!this.validateReseller()) {
    this.toastr.warning('Please enter valid reseller details.');
    return;
  }

  if (!this.paymentMode) {
    this.toastr.warning('Please select a payment method.');
    return;
  }

  if (!this.razorpayKey) {
    this.toastr.error('Razorpay configuration is missing.');
    return;
  }

  this.isProcessingPayment = true;
  this.paymentFlowFinished = false;
  this.currentRazorpayOrderId = '';

  this.trackPaymentEvent(
    'PAYMENT_INITIATED',
    `Payment initiated, cartId=${this.cartId}, paymentMode=${this.paymentMode}`
  );

  this.trackPaymentEvent(
    'PAYMENT_AMOUNT_CONFIRMED',
    `Payable amount=${Number(this.payNowAmount || 0).toFixed(2)} INR, cartId=${this.cartId}, paymentMode=${this.paymentMode}`
  );

  const orderPayload = {
    cartId: this.cartId,
    shippingAmount: Number(this.selectedShipping?.amount || 0),
    shippingPartner: this.selectedShipping?.shippingPartner || '',
    discountAmount: Number(this.discountTotal || 0),
    orderType: this.paymentMode,
    codAmount: Number(this.codAmount || 0)
  };

  this.spinner.show();

  this.appService.createRazorpayOrder(orderPayload).subscribe({
    next: (order: any) => {
      this.spinner.hide();

      if (
        !order?.orderId ||
        order?.amount === null ||
        order?.amount === undefined ||
        !order?.currency ||
        Number(order.amount) <= 0
      ) {
        this.isProcessingPayment = false;

        this.trackPaymentEvent(
          'PAYMENT_FAILED',
          `Invalid Razorpay order response, cartId=${this.cartId}`
        );

        this.toastr.error(
          'Invalid payment order response. Please try again.'
        );
        return;
      }

      this.currentRazorpayOrderId = order.orderId;

      this.trackPaymentEvent(
        'RAZORPAY_ORDER_CREATED',
        `Razorpay order created, cartId=${this.cartId}, razorpayOrderId=${order.orderId}, amountPaise=${order.amount}`
      );

      this.openRazorpay(order);
    },

    error: (error: any) => {
      this.spinner.hide();
      this.isProcessingPayment = false;

      const action =
        error?.status === 0
          ? 'PAYMENT_NETWORK_ERROR'
          : 'PAYMENT_FAILED';

      this.trackPaymentEvent(
        action,
        `Razorpay order creation failed, cartId=${this.cartId}, status=${error?.status ?? 'unknown'}`
      );

      this.toastr.error(
        error?.error?.message ||
        'Unable to create payment order. Please try again.'
      );
    }
  });
}


  getDisableReason(): string {

    if (!this.items?.length) {
      return 'Your cart is empty.';
    }

    if (this.selectedUserAddressId === null || this.selectedUserAddressId === undefined) {
      return 'Please select delivery address.';
    }

    if (this.shippingDetails?.length && !this.selectedShipping) {
      return 'Please choose delivery method.';
    }

    if (this.buyerType === 'RESELLER') {

      if (!this.resellerName?.trim()) {
        return 'Please enter reseller name.';
      }

      if (!this.phonePattern?.test(this.resellerPhone)) {
        return 'Please enter valid reseller phone.';
      }

    }

    if (!this.paymentMode) {
      return 'Please select payment method.';
    }

    return '';
  }

  isPlaceOrderDisabled(): boolean {

    if (!this.items?.length) return true;

    if (this.selectedUserAddressId === null || this.selectedUserAddressId === undefined) {
      return true;
    }

    if (!this.paymentMode) return true;

    if (this.shippingDetails?.length && !this.selectedShipping) return true;

    if (this.buyerType === 'RESELLER') {

      if (!this.resellerName?.trim()) return true;

      if (!this.phonePattern?.test(this.resellerPhone)) return true;

    }

    return false;
  }

  loadRazorpayScript(): Promise<boolean> {
    return new Promise((resolve) => {

      if ((window as any).Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;

      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  }


  async openRazorpay(order: any): Promise<void> {
  this.isProcessingPayment = true;
  this.checkoutDismissed = false;

  const loaded = await this.loadRazorpayScript();

  if (!loaded) {
    this.isProcessingPayment = false;

    this.trackPaymentEvent(
      'PAYMENT_NETWORK_ERROR',
      `Razorpay SDK failed to load, cartId=${this.cartId}, razorpayOrderId=${order.orderId}`
    );

    this.toastr.error('Unable to load the payment gateway.');
    return;
  }

  this.trackPaymentEvent(
    'PAYMENT_GATEWAY_LOADED',
    `Razorpay SDK loaded, cartId=${this.cartId}, razorpayOrderId=${order.orderId}`
  );

  const selectedAddress = this.getSelectedAddress();

  const options: any = {
    key: this.razorpayKey,
    amount: Number(order.amount),
    currency: order.currency,
    order_id: order.orderId,

    name: 'Budget Bazaar',
    description: 'Order Payment',

    prefill: {
      name: selectedAddress?.name || '',
      contact: selectedAddress?.phoneNumber || ''
    },

    handler: (response: any) => {
      this.clearPaymentTimeout();

      this.trackPaymentEvent(
        'PAYMENT_VERIFICATION_STARTED',
        `Payment response received, cartId=${this.cartId}, razorpayOrderId=${response?.razorpay_order_id || order.orderId}`
      );

      // Do not reset processing here.
      // Wait for backend verification.
      this.verifyPayment(response);
    },

    modal: {
      ondismiss: () => {
        if (this.paymentFlowFinished || this.confirmingOrder) {
          return;
        }

        this.checkoutDismissed = true;
        this.clearPaymentTimeout();
        this.isProcessingPayment = false;

        this.trackPaymentEvent(
          'PAYMENT_CANCELLED_BY_USER',
          `Checkout closed by user, cartId=${this.cartId}, razorpayOrderId=${order.orderId}`
        );

        this.trackPaymentEvent(
          'PAYMENT_CANCELLED',
          `Checkout dismissed, cartId=${this.cartId}, razorpayOrderId=${order.orderId}`
        );

        // Cancellation is not an error.
        this.toastr.info(
          'Payment cancelled. You can try again.',
          'Payment Cancelled'
        );
      }
    },

    theme: {
      color: '#3399cc'
    }
  };

  try {
    const razorpay = new Razorpay(options);

    razorpay.on('payment.failed', (response: any) => {
      // Ignore failure events associated with a dismissed checkout.
      if (this.checkoutDismissed || this.paymentFlowFinished) {
        return;
      }

      this.clearPaymentTimeout();
      this.isProcessingPayment = false;

      const error = response?.error || {};
      const description =
        error.description || 'Payment failed. Please try again.';

      const isNetworkError =
        error.code === 'NETWORK_ERROR' ||
        String(description).toLowerCase().includes('network');

      this.trackPaymentEvent(
        isNetworkError ? 'PAYMENT_NETWORK_ERROR' : 'PAYMENT_FAILED',
        `Payment failed, cartId=${this.cartId}, razorpayOrderId=${order.orderId}, reason=${description}`
      );

      // Only actual payment failures display an error toast.
      this.toastr.error(description, 'Payment Failed');
    });

    razorpay.open();

    this.trackPaymentEvent(
      'PAYMENT_GATEWAY_OPENED',
      `Razorpay Checkout opened, cartId=${this.cartId}, razorpayOrderId=${order.orderId}`
    );

    this.startPaymentTimeoutTracking();

  } catch (error: any) {
    this.clearPaymentTimeout();
    this.isProcessingPayment = false;

    this.trackPaymentEvent(
      'PAYMENT_FAILED',
      `Could not open Razorpay Checkout, cartId=${this.cartId}, message=${error?.message || 'unknown'}`
    );

    this.toastr.error(
      'Unable to open the payment gateway. Please try again.'
    );
  }
}



  verifyPayment(res: any): void {
  if (this.confirmingOrder || this.paymentFlowFinished) {
    return;
  }

  if (
    !res?.razorpay_order_id ||
    !res?.razorpay_payment_id ||
    !res?.razorpay_signature
  ) {
    this.isProcessingPayment = false;

    this.trackPaymentEvent(
      'PAYMENT_VERIFICATION_FAILED',
      `Missing Razorpay verification fields, cartId=${this.cartId}`
    );

    this.toastr.error(
      'Payment verification details are missing. Please contact support.'
    );
    return;
  }

  const selectedAddress = this.getSelectedAddress();

  if (!selectedAddress) {
    this.isProcessingPayment = false;

    this.trackPaymentEvent(
      'PAYMENT_VERIFICATION_FAILED',
      `Delivery address missing during payment confirmation, cartId=${this.cartId}`
    );

    this.toastr.error('Delivery address not found.');
    return;
  }

  this.confirmingOrder = true;
  this.isProcessingPayment = true;
  this.spinner.show();

  const payload = {
    razorpayOrderId: res.razorpay_order_id,
    razorpayPaymentId: res.razorpay_payment_id,
    razorpaySignature: res.razorpay_signature,

    shippingAmount: Number(this.shipping || 0),
    discountAmount: Number(this.discountTotal || 0),
    shippingPartner: this.selectedShipping?.shippingPartner || '',

    cartId: this.cartId,
    buyerType: this.buyerType,

    resellerName:
      this.buyerType === 'RESELLER' ? this.resellerName : '',

    resellerPhone:
      this.buyerType === 'RESELLER' ? this.resellerPhone : '',

    gstNumber: this.gstNumber || '',

    addressId: selectedAddress.addressId,
    codAmount: Number(this.codAmount || 0),

    addresses: [selectedAddress]
  };

  this.appService.confirmOrder(payload).subscribe({
    next: () => {
      this.spinner.hide();

      this.confirmingOrder = false;
      this.isProcessingPayment = false;
      this.paymentFlowFinished = true;

      this.clearPaymentTimeout();

      this.trackPaymentEvent(
        'PAYMENT_VERIFICATION_SUCCESS',
        `Backend accepted payment verification, cartId=${this.cartId}, razorpayOrderId=${res.razorpay_order_id}, paymentId=${res.razorpay_payment_id}`
      );

      this.trackPaymentEvent(
        'PAYMENT_SUCCESS',
        `Payment confirmed by backend, cartId=${this.cartId}, razorpayOrderId=${res.razorpay_order_id}`
      );

      this.trackPaymentEvent(
        'ORDER_CREATED',
        `Order successfully created after payment confirmation, cartId=${this.cartId}, razorpayOrderId=${res.razorpay_order_id}`
      );

      this.trackPaymentEvent(
        'ORDER_CONFIRMED',
        `Order confirmation API succeeded, cartId=${this.cartId}, razorpayOrderId=${res.razorpay_order_id}`
      );

      this.toastr.success('Order placed successfully!');

      this.cartState.clearCart();
      this.router.navigate(['/my-orders']);
    },

    error: (error: any) => {
      this.spinner.hide();

      this.confirmingOrder = false;
      this.isProcessingPayment = false;

      this.trackPaymentEvent(
        'PAYMENT_VERIFICATION_FAILED',
        `Payment/order confirmation API failed, cartId=${this.cartId}, razorpayOrderId=${res.razorpay_order_id}, status=${error?.status ?? 'unknown'}`
      );

      this.toastr.error(
        'Payment confirmation could not be completed. Please check My Orders before trying again.'
      );
    }
  });
}



  getSelectedAddress() {
    return this.userAddresses.find(
      a => a.addressId === this.selectedUserAddressId
    );
  }

  getByCustomerCartDetails() {
    this.spinner.show();

    this.appService.getByCustomerCartDetails().subscribe({
      next: (res: any[]) => {
        this.spinner.hide();

        const cart = res?.[0];

        if (!cart || !cart.cartItems?.length) {
          this.items = [];
          this.cartState.clearCart();
          return;
        }

        this.items = cart.cartItems.map((ci: any) => {

          const variant = ci.productVariant;
          const primaryImg = variant?.images?.find((img: any) => img.isPrimary);

          return {
            cartItemId: ci.cartItemId,

            name: variant?.productName ?? '',

            // USE API PRICE (not SRP)
            price: ci.itemPrice ?? 0,

            // quantity field from API
            qty: ci.quantity ?? 0,

            // pass discounts array
            discounts: ci.discounts ?? [],

            categoryId: ci.categoryId,
            barcodeNumber: variant?.barcodeNumber,

            imageId: primaryImg?.imageDetailsId ?? null
          };
        });
        this.cartId = cart.cartId;
        this.cartState.setItems(this.items);
        this.recalculateCart();

        // NOW load category → then address → then shipping
        this.loadCategoryAndAddress(cart.cartId, cart.userId);
      },

      error: err => {
        this.spinner.hide();
        this.toastr.error(err.error?.message || 'Failed to load cart');
      }
    });
  }

  loadCategoryAndAddress(cartId: number, userId: number) {

    // Load category details first (shipping rules needed)
    this.appService.getByCartCategoryDetails(cartId).subscribe({
      next: (catRes: CategoryDetails[]) => {

        this.categoryDetails = catRes;
        this.isCodAvailable = catRes.some(c => c.isCodAvailable === true);

        // After category ready → load address
        this.loadCustomerAddress(userId);
      },
      error: err => {
        this.spinner.hide();
        this.toastr.error('Failed to load category details');
      }
    });
  }


  loadCustomerAddress(userId: number) {

    this.appService.getByCustomerAddressDetails(userId).subscribe({
      next: (addrRes: Address[]) => {

        this.spinner.hide();
        this.userAddresses = addrRes || [];

        if (this.userAddresses.length) {

          const defaultAddress = this.userAddresses[0];

          this.selectedUserAddressId = defaultAddress.addressId;

          // ✅ NOW everything is ready → shipping will work

          if (this.selectedState) {
            this.calculateItemWiseShipping(this.selectedState);
          } else {
            this.calculateItemWiseShipping(defaultAddress.state);
          }
        }
      },
      error: err => {
        this.spinner.hide();
        this.toastr.error('Failed to load address details');
      }
    });
  }


  trackPaymentEvent(
  action: string,
  description: string
): void {
  const payload = {
    action,
    screenName: this.paymentScreenName,
    description
  };

  this.appService.saveUserTracking(payload).subscribe({
    next: () => {
      // Tracking event saved.
    },
    error: (error: any) => {
      // Do not interrupt payment if tracking fails.
      console.warn('Payment tracking failed:', action, error);
    }
  });
}

private clearPaymentTimeout(): void {
  if (this.paymentTimeoutHandle !== null) {
    clearTimeout(this.paymentTimeoutHandle);
    this.paymentTimeoutHandle = null;
  }
}

private startPaymentTimeoutTracking(): void {
  this.clearPaymentTimeout();

  this.paymentTimeoutHandle = setTimeout(() => {
    if (!this.paymentFlowFinished) {
      this.trackPaymentEvent(
        'PAYMENT_TIMEOUT',
        `Payment gateway remained unresolved for cartId=${this.cartId}, razorpayOrderId=${this.currentRazorpayOrderId}`
      );
    }
  }, 5 * 60 * 1000);
}

  updatePaymentBreakup() {

    const subtotal = this.productTotal - this.discountTotal;
    if (this.paymentMode === 'COD') {
      // COD → No shipping included
      this.orderValue = subtotal;
      this.payNowAmount = this.codAmount;
      this.payLaterAmount = subtotal;
    } else {
      // ONLINE → Include shipping
      this.orderValue = subtotal + this.shipping;
      this.payNowAmount = this.orderValue;
      this.payLaterAmount = 0;
    }
  }

  calculateItemWiseShipping(selectedState: string) {

    if (!selectedState || !this.items?.length) {
      this.shippingDetails = [];
      this.shipping = 0;
      return;
    }

    const zone = this.getZoneByState(selectedState);

    const partnerCostMap = new Map<string, number>();
    const partnerFreeMap = new Map<string, boolean>();

    this.items.forEach(item => {

      const category = this.categoryDetails
        .find(c => c.categoryId === item.categoryId);

      if (!category?.shippingList) return;

      const qty = item.qty;

      category.shippingList.forEach(rule => {

        if (!rule.isActive) return;
        if (rule.state !== zone) return;

        if (qty < rule.productStartRange || qty > rule.productEndRange) return;

        const partner = rule.shippingPartner;

        // FREE SHIPPING
        if (rule.shippingType === 'FREE' || rule.shippingAmount === 0) {
          partnerFreeMap.set(partner, true);
          partnerCostMap.set(partner, 0);
          return;
        }

        if (partnerFreeMap.get(partner)) return;

        let cost = 0;

        if (rule.rateType === 'PER_PRODUCT') {
          cost = rule.shippingAmount * qty;
        }

        if (rule.rateType === 'FLAT_RATE') {
          cost = rule.shippingAmount;
        }

        // store lowest cost for this partner
        const existing = partnerCostMap.get(partner);

        if (existing === undefined) {
          partnerCostMap.set(partner, cost);
        } else {
          partnerCostMap.set(partner, Math.min(existing, cost));
        }

      });

    });

    this.shippingDetails = Array.from(partnerCostMap.entries()).map(([partner, amount]) => ({
      shippingPartner: partner,
      shippingType: partnerFreeMap.get(partner) ? 'FREE' : 'PAID',
      amount: partnerFreeMap.get(partner) ? 0 : amount
    }));

    // sort lowest shipping
    this.shippingDetails.sort((a, b) => a.amount - b.amount);

    if (this.shippingDetails.length) {
      this.selectedShipping = this.shippingDetails[0];
      this.shipping = this.selectedShipping.amount;
      this.shippingPartner = this.selectedShipping.shippingPartner;
    }

    this.updatePaymentBreakup();
  }

  isQtyInRange(qty: number, start: number, end: number): boolean {
    return qty >= start && qty <= end;
  }

  resolveShippingPartnerTotal(partner: any) {
    let totalAmount = 0;
    partner.rules.forEach((rule: any) => {
      let amount = 0;
      if (rule.rateType === 'FLAT_RATE') {
        amount += Number(rule.shippingAmount);
      }
      if (rule.rateType === 'PER_PRODUCT') {
        amount += Number(rule.shippingAmount) * rule.itemQty;
      }

      totalAmount += amount;

    });

    return {
      shippingId: partner.shippingId,
      shippingPartner: partner.shippingPartner,
      shippingType: 'PAID',
      amount: totalAmount
    };
  }

  getCategoryCartQuantity(categoryId: number): number {
    return this.items
      .filter(i => i.categoryId === categoryId)
      .reduce((sum, i) => sum + i.qty, 0);
  }


  calculateCODCharges() {

    if (this.paymentMode !== 'COD') {
      this.codAmount = 0;
      this.updatePaymentBreakup();
      return;
    }

    let totalQty = 0;
    let codAmount = 0;
    let additionalAmount = 0;

    // total quantity of cart
    this.items.forEach(item => {
      totalQty += item.qty;
    });

    // get first available COD rule
    for (let cat of this.categoryDetails) {

      if (!cat.isCodAvailable) continue;

      const rule = cat.codDetailsList?.[0];

      if (rule) {
        codAmount = Number(rule.codAmount || 0);
        additionalAmount = Number(rule.additionalAmount || 0);
        break;
      }
    }
    if (totalQty >= 1) {

      let codTotal = codAmount;

      if (totalQty > 1) {
        codTotal += (totalQty - 1) * additionalAmount;
      }
      this.codAmount = codTotal;
    } else {
      this.codAmount = 0;
    }
    this.updatePaymentBreakup();

  }


  selectUserAddress(addr: any) {
    this.selectedUserAddressId = addr.addressId;
    // reset shipping
    this.shippingDetails = [];
    this.selectedShipping = null;
    this.shipping = 0;

    // recalc shipping
    this.calculateItemWiseShipping(addr.state);
    this.selectedState = addr.state;

  }

  recalculateCart() {

    let productSum = 0;
    let discountSum = 0;
    let totalQty = 0;

    // STEP 1: calculate overall quantity
    this.items.forEach((item: any) => {
      totalQty += Number(item.qty) || 0;
    });

    // STEP 2: calculate totals
    this.items.forEach((item: any) => {

      const qty = Number(item.qty) || 0;
      const price = Number(item.price) || 0;

      const itemTotal = qty * price;
      productSum += itemTotal;

      let bestDiscount = 0;

      if (item.discounts && item.discounts.length) {
        const eligibleSlabs = item.discounts
          .filter((d: any) => totalQty >= d.discountQuantity)
          .sort((a: any, b: any) => b.discountQuantity - a.discountQuantity);

        if (eligibleSlabs.length > 0) {
          const slab = eligibleSlabs[0];
          // discount per product qty
          bestDiscount = slab.discountAmount * qty;
        }
      }
      item.calculatedDiscount = bestDiscount;
      discountSum += bestDiscount;

    });

    this.productTotal = productSum;
    this.discountTotal = discountSum;

    this.showDiscount = this.discountTotal > 0;

    this.updatePaymentBreakup();

  }

  getCartTotalQty(): number {
    return this.items.reduce((sum, i) => sum + i.qty, 0);
  }

  get subtotal(): number {
    return this.productTotal - this.discountTotal;
  }

  get total(): number {
    let total = this.subtotal + this.shipping;
    if (this.paymentMode === 'COD') {
      total += this.codAmount;
    }
    return total;
  }


  // ================= CART ACTIONS =================

  updateQuantity(item: any, change: number) {
    const newQty = item.qty + change;
    if (newQty < 1) return;
    this.spinner.show();
    const jsonData = {
      cartItemId: item.cartItemId,
      quantity: newQty
    };
    this.appService.updateCartQuantity(jsonData).subscribe({
      next: () => {
        item.qty = newQty;
        this.cartState.setItems(this.items);
        // SHIPPING RECALCULATION USING STORED STATE
        if (this.selectedState) {
          this.calculateItemWiseShipping(this.selectedState);
        }
        this.calculateCODCharges();
        this.recalculateCart();

        this.spinner.hide();

      },
      error: err => {
        this.spinner.hide();
        this.toastr.error(err.error?.message || 'Failed to update quantity');
      }
    });
  }


  removeItem(cartItemId: number, index: number) {
    this.spinner.show();
    this.appService.removeCartItemDetails(cartItemId).subscribe({
      next: () => {
        this.items.splice(index, 1); // remove from UI
        this.spinner.hide();
        this.toastr.success('Item removed from cart');
        this.calculateItemWiseShipping(this.selectedState);
        this.calculateCODCharges();
        this.getByCustomerCartDetails();
      },
      error: err => {
        this.spinner.hide();
        this.toastr.error(err.error?.message || 'Failed to remove item');
      }
    });
  }


  // ================= CALCULATIONS =================

  get tax() {
    return this.subtotal * this.taxRate;
  }

  // ================= IMAGE =================

  getImageByVariant(imageDetailsId: number | null | undefined): string {
    return imageDetailsId
      ? `${this.endPoint}/api/product/image-details/get/${imageDetailsId}`
      : 'assets/img/my-1.jpg';
  }

  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/img/my-1.jpg';
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  onStateChange(event: any) {

    const state = event.target.value;
    this.selectedState = state;

    if (!state) return;

    this.selectedShipping = null;
    this.shipping = 0;
    this.shippingDetails = [];

    this.calculateItemWiseShipping(state);

  }

  // Indian Currency Formatter
  formatIndianCurrency(value: number | string): string {
    if (value === null || value === undefined || value === '') return '0.00';

    const number = Number(value);

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(number);
  }

}
